export class GdsgInventoryReportRun {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "environmentId",
            "baseName": "environmentId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "configurationId",
            "baseName": "configurationId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "configurationDisplayName",
            "baseName": "configurationDisplayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "inventoryDate",
            "baseName": "inventoryDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "snapshotAt",
            "baseName": "snapshotAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "GdsgInventoryReportRunStatus",
            "format": ""
        },
        {
            "name": "startedAt",
            "baseName": "startedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "completedAt",
            "baseName": "completedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "errorMessage",
            "baseName": "errorMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "failureReason",
            "baseName": "failureReason",
            "type": "GdsgInventoryReportRunFailureReason",
            "format": ""
        },
        {
            "name": "reportPathPrefix",
            "baseName": "reportPathPrefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "destinationBucketName",
            "baseName": "destinationBucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return GdsgInventoryReportRun.attributeTypeMap;
    }
    constructor() {
    }
}
